/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {deleteExtensionOauth} from '../api'

export const useMutationDeleteExtensionOauth = createReactQueryMutationHook('deleteExtensionOauth', deleteExtensionOauth)
